import { RepairShop } from "../../model/RepairShop";

/**
 * 엔진오일 서비스를 제공하는 장착점인지 확인합니다.
 * 공임표 메뉴 노출과 페이지 접근 제어에서 동일한 기준을 사용합니다.
 */
export const canAccessLaborFee = (repairShop: RepairShop | null): boolean => {
  const engineOilOption =
    repairShop?.repairShopOption?.options?.services?.engineoil;
  const canAccess = engineOilOption?.isActivated === true;

  // 요청에 따라 실제 옵션 원본과 최종 접근 여부를 브라우저 콘솔에서 확인합니다.
  // eslint-disable-next-line no-console
  console.info("[공임표 접근 조건]", {
    repairShopId: repairShop?.id,
    repairShopOption: repairShop?.repairShopOption,
    engineOilOption,
    engineOilIsActivated: engineOilOption?.isActivated,
    canAccessLaborFee: canAccess,
  });

  return canAccess;
};
